import { IStorageState } from './IStorageState';
import { IUser } from 'src/app/models/IUser';
import { ConfigService } from 'src/app/Services/config.service';

export class SessionStorageState implements IStorageState {
  private _config: ConfigService = new ConfigService();

  constructor() {}

  ReadCurrentUser(): IUser {
    return JSON.parse(
      sessionStorage.getItem(this._config.currentUserStorageName)
    );
  }
  ReadAuthToken(): string {
    return sessionStorage.getItem(this._config.authTokenStorageName);
  }

  StoreAuthToken(token: string): void {
    sessionStorage.setItem(this._config.authTokenStorageName, token);
  }
  StoreCurrentUser(user: IUser): void {
    sessionStorage.setItem(
      this._config.currentUserStorageName,
      JSON.stringify(user)
    );
  }
  RemoveAuthToken(): void {
    sessionStorage.removeItem(this._config.authTokenStorageName);
  }
  RemoveCurrentUser(): void {
    sessionStorage.removeItem(this._config.currentUserStorageName);
  }
}
